<template>
  <div class="bill-page">
    <div v-if="loading" class="loading-wrap">
      <van-loading type="spinner" color="#3f8aec">加载中...</van-loading>
    </div>

    <template v-else-if="contract">
      <div class="hero">
        <div
          v-if="showSettleCert"
          class="cert-btn"
          @click="goSettleCert"
        >结清证明</div>
        <div class="hero-date">{{ loanDateText }} 借款(元)</div>
        <div class="hero-amount">{{ moneyFmt(contract.principal) }}</div>
        <div class="hero-term">共{{ contract.term || 0 }}期 剩余{{ pendingCount }}期</div>
      </div>

      <div class="card detail-card">
        <div class="row link-row" @click="toastSoon('借款用途证明')">
          <span>上传借款用途证明</span>
          <van-icon name="arrow" />
        </div>
        <div class="row section-row" @click="detailOpen = !detailOpen">
          <span>借款明细及协议</span>
          <van-icon :name="detailOpen ? 'arrow-up' : 'arrow-down'" class="circle-arrow" />
        </div>
        <div v-show="detailOpen" class="detail-list">
          <div class="kv">
            <span>还款方式</span>
            <b>等额本息</b>
          </div>
          <div class="kv">
            <span>合同协议</span>
            <a @click.stop="goContract">查看协议 &gt;</a>
          </div>
          <div class="kv">
            <span>借款单据</span>
            <b class="mono">{{ contract.contract_no }}</b>
          </div>
        </div>
      </div>

      <div class="card plan-card">
        <div class="tabs">
          <div
            class="tab"
            :class="{ active: tab === 'pending' }"
            @click="tab = 'pending'"
          >待还计划</div>
          <div
            class="tab"
            :class="{ active: tab === 'paid' }"
            @click="tab = 'paid'"
          >已还明细</div>
        </div>

        <div v-if="tab === 'pending'" class="pending-sum" @click="planOpen = !planOpen">
          <span>待还总金额</span>
          <div class="sum-right">
            <b>¥{{ money(pendingTotal) }}</b>
            <van-icon :name="planOpen ? 'arrow-up' : 'arrow-down'" />
          </div>
        </div>

        <div v-show="tab === 'pending' ? planOpen : true" class="timeline">
          <div
            v-for="(item, idx) in displayList"
            :key="item.id"
            class="tl-item"
          >
            <div class="tl-left">
              <div class="period">{{ item.period }}期</div>
              <div class="date">{{ shortDate(item.due_date || item.paid_at) }}</div>
              <div v-if="idx < displayList.length - 1" class="line" />
            </div>
            <div class="tl-right">
              <div class="amt">¥{{ money(rowAmount(item)) }}</div>
              <div class="break">
                本金{{ money(item.principal_amount) }}
                + 利息{{ money(item.interest_amount) }}
                <template v-if="Number(item.penalty_amount) > 0">
                  + 违约金{{ money(item.penalty_amount) }}
                </template>
              </div>
              <div v-if="tab === 'paid'" class="paid-tag">已还清</div>
            </div>
          </div>
          <div v-if="!displayList.length" class="empty-tip">暂无数据</div>
        </div>
      </div>

      <div class="footer-space" />
      <div class="footer">
        <van-button
          block
          round
          color="linear-gradient(to right,#6aa8f5, #3d8aef)"
          :disabled="!pendingCount"
          @click="goRepay"
        >
          <div class="btn-main">去还款</div>
          <div class="btn-sub">{{ footerTip }}</div>
        </van-button>
      </div>
    </template>

    <div v-else class="empty">
      <img src="../../assets/img/zw1.png" alt="" />
      <p>暂无借款记录</p>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'
import { bills, contracts } from '@/api/request.js'

export default {
  name: 'TabBill',
  data() {
    return {
      loading: true,
      tab: 'pending',
      detailOpen: true,
      planOpen: true,
      contract: null,
      pendingList: [],
      paidList: []
    }
  },
  computed: {
    pendingCount() {
      return this.pendingList.length
    },
    pendingTotal() {
      return this.pendingList.reduce(
        (s, b) => s + Math.max(0, Number(b.amount || 0) - Number(b.paid_amount || 0)),
        0
      )
    },
    displayList() {
      return this.tab === 'pending' ? this.pendingList : this.paidList
    },
    loanDateText() {
      const d = this.contract && (this.contract.disburse_at || this.contract.start_date)
      if (!d) return ''
      const s = String(d).slice(0, 10)
      const [y, m, day] = s.split('-')
      if (!y) return s
      return `${y}年${Number(m)}月${Number(day)}日`
    },
    footerTip() {
      if (!this.pendingCount) return '暂无待还账单'
      return '请按时还款，理性消费'
    },
    showSettleCert() {
      if (!this.contract) return false
      if (this.contract.settled) return true
      return this.pendingCount === 0 && this.paidList.length > 0
    }
  },
  methods: {
    money(n) {
      return Number(n || 0).toFixed(2)
    },
    moneyFmt(n) {
      return Number(n || 0).toLocaleString('zh-CN', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      })
    },
    shortDate(d) {
      if (!d) return '-'
      const s = String(d).slice(0, 10)
      const parts = s.split('-')
      if (parts.length < 3) return s
      return `${parts[0].slice(2)}/${parts[1]}/${parts[2]}`
    },
    rowAmount(item) {
      if (this.tab === 'paid') return Number(item.paid_amount || item.amount || 0)
      return Math.max(0, Number(item.amount || 0) - Number(item.paid_amount || 0))
    },
    toastSoon(name) {
      Toast(`${name}功能暂未开放`)
    },
    goContract() {
      if (!this.contract) return
      this.$router.push(`/contract-detail/${this.contract.id}`)
    },
    goSettleCert() {
      if (!this.contract) return
      this.$router.push(`/settle-cert/${this.contract.id}`)
    },
    goRepay() {
      if (!this.pendingCount) {
        Toast('暂无待还账单')
        return
      }
      this.$router.push('/repay')
    },
    async load() {
      this.loading = true
      try {
        const [cRes, pRes, paidRes] = await Promise.all([
          contracts(),
          bills('pending'),
          bills('paid')
        ])
        const contractList = cRes.data || []
        const pending = pRes.data || []
        const paid = paidRes.data || []

        // 优先展示有待还账单的合同，否则最新合同
        let current = null
        if (pending.length) {
          current = contractList.find((c) => pending.some((b) => b.contract_id === c.id))
        }
        if (!current) current = contractList[0] || null
        this.contract = current

        if (current) {
          this.pendingList = pending
            .filter((b) => b.contract_id === current.id)
            .sort((a, b) => a.period - b.period)
          this.paidList = paid
            .filter((b) => b.contract_id === current.id)
            .sort((a, b) => a.period - b.period)
        } else {
          this.pendingList = []
          this.paidList = []
        }
      } finally {
        this.loading = false
      }
    }
  },
  mounted() {
    this.load()
  },
  activated() {
    this.load()
  }
}
</script>

<style lang="less" scoped>
.bill-page {
  min-height: 100%;
  background: #f3f6fb;
  padding: 12px 12px 100px;
  box-sizing: border-box;
  overflow: auto;
}
.loading-wrap {
  padding: 80px 0;
  text-align: center;
}
.hero {
  position: relative;
  background: linear-gradient(180deg, #4b96f0 0%, #3d8aef 100%);
  border-radius: 14px 14px 0 0;
  color: #fff;
  padding: 20px 16px 18px;
  .cert-btn {
    position: absolute;
    top: 14px;
    right: 12px;
    padding: 4px 10px;
    border-radius: 12px;
    border: 1px solid rgba(255, 255, 255, 0.85);
    background: rgba(255, 255, 255, 0.16);
    color: #fff;
    font-size: 12px;
    line-height: 1.4;
    z-index: 2;
  }
  .hero-date {
    font-size: 13px;
    opacity: 0.95;
    padding-right: 78px;
  }
  .hero-amount {
    margin-top: 8px;
    font-size: 40px;
    font-weight: 700;
    letter-spacing: 1px;
    line-height: 1.1;
  }
  .hero-term {
    margin-top: 10px;
    font-size: 13px;
    opacity: 0.92;
  }
}
.card {
  background: #fff;
  border-radius: 0 0 14px 14px;
  box-shadow: 0 4px 14px rgba(31, 45, 61, 0.04);
}
.detail-card {
  margin-bottom: 12px;
  border-radius: 0 0 14px 14px;
}
.row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  font-size: 14px;
  color: #333;
  border-bottom: 1px solid #f2f4f7;
}
.link-row {
  color: #666;
  .van-icon { color: #c0c4cc; }
}
.section-row {
  font-weight: 600;
  border-bottom: none;
}
.circle-arrow {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #f0f3f8;
  color: #9aa3af;
  font-size: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.detail-list {
  padding: 0 16px 12px;
}
.kv {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  padding: 10px 0;
  font-size: 13px;
  color: #999;
  b {
    color: #333;
    font-weight: 500;
    text-align: right;
    max-width: 62%;
    word-break: break-all;
  }
  .mono {
    font-size: 12px;
  }
  a {
    color: #3f8aec;
  }
}
.plan-card {
  border-radius: 14px;
  padding-bottom: 8px;
}
.tabs {
  display: flex;
  border-bottom: 1px solid #f0f2f5;
  .tab {
    flex: 1;
    text-align: center;
    padding: 14px 0 12px;
    font-size: 14px;
    color: #666;
    position: relative;
  }
  .tab.active {
    color: #3f8aec;
    font-weight: 600;
  }
  .tab.active::after {
    content: '';
    position: absolute;
    left: 50%;
    bottom: 0;
    width: 28px;
    height: 3px;
    border-radius: 2px;
    background: #3f8aec;
    transform: translateX(-50%);
  }
}
.pending-sum {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 16px 8px;
  font-size: 13px;
  color: #666;
  .sum-right {
    display: flex;
    align-items: center;
    gap: 4px;
    b {
      color: #ff3b30;
      font-size: 16px;
      font-weight: 700;
    }
    .van-icon { color: #c0c4cc; font-size: 12px; }
  }
}
.timeline {
  padding: 4px 16px 12px;
}
.tl-item {
  display: flex;
  gap: 14px;
  min-height: 64px;
}
.tl-left {
  width: 52px;
  position: relative;
  flex-shrink: 0;
  .period {
    font-size: 14px;
    color: #333;
    font-weight: 600;
  }
  .date {
    margin-top: 2px;
    font-size: 11px;
    color: #999;
  }
  .line {
    position: absolute;
    left: 10px;
    top: 36px;
    bottom: 0;
    width: 1px;
    background: #e6eaf0;
  }
}
.tl-right {
  flex: 1;
  padding-bottom: 16px;
  .amt {
    font-size: 16px;
    font-weight: 700;
    color: #222;
  }
  .break {
    margin-top: 4px;
    font-size: 12px;
    color: #999;
  }
  .paid-tag {
    margin-top: 4px;
    font-size: 12px;
    color: #07c160;
  }
}
.empty-tip {
  text-align: center;
  color: #999;
  font-size: 13px;
  padding: 24px 0;
}
.footer {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 50px;
  padding: 10px 16px calc(10px + env(safe-area-inset-bottom));
  background: transparent;
  z-index: 20;
  .van-button {
    height: 48px;
    line-height: 1.1;
  }
  .btn-main {
    font-size: 16px;
    font-weight: 600;
  }
  .btn-sub {
    margin-top: 2px;
    font-size: 11px;
    opacity: 0.9;
  }
}
.footer-space {
  height: 70px;
}
.empty {
  padding-top: 80px;
  text-align: center;
  img { width: 5.46rem; margin: 0 auto; }
  p { margin-top: 12px; color: #999; font-size: 14px; }
}
</style>
